import { Button, TextField } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useEffect, useState } from "react";
import { useDataLayerValue } from "../../Reducer/DataLayer";

import addAutoplay from "../../_utils/ytAutoplay";

const YoutubeEmbeded = () => {
  const classes = useStyles();

  const [{ yt_embeded_link }, dispatch] = useDataLayerValue();

  const [dummy, setDummy] = useState("");

  useEffect(() => {
    setDummy(yt_embeded_link);
  }, [yt_embeded_link]);
  const handleYoutubeEmbeded = async (e) => {
    e.preventDefault();

    // if (dummy?.substring(0, 7) === "<iframe") {
    let newYT = await addAutoplay(dummy);

    await dispatch({
      type: "ADD_YT_EMBEDED",
      payload: { yt_embeded_link: dummy },
    });
    document.getElementById("yt_embeded_video").innerHTML = `${newYT}`;
    // } else {
    //   document.getElementById("yt_embeded_video").innerHTML = `
    //     <h5>Enter a valid EMBEDED link</h5>`;
    // }
  };

  return (
    <div className={classes.embeded}>
      {/* EMBEDED VIDEO */}
      <div className="" id="yt_embeded_video"></div>

      {/* EMBEDED LINK */}
      <TextField
        label="Youtube Embeded Link"
        variant="filled"
        placeholder="Enter Youtube Embeded Link"
        className={classes.embeded_link}
        value={dummy}
        onChange={(e) => setDummy(e.target.value)}
      />
      <Button
        variant="contained"
        color="primary"
        className="my-1"
        onClick={handleYoutubeEmbeded}
      >
        {dummy === "" ? "Add" : "Preview"}
      </Button>
    </div>
  );
};

export default YoutubeEmbeded;

const useStyles = makeStyles(() => ({
  embeded: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#f2f4fc",
    borderRadius: "0.5rem",
    margin: "1rem 0.125rem",
    padding: "0.5rem 0",
    "& iframe": {
      width: "40rem",
      // height: "auto",
      
      margin: "0.5rem 0 0 0",
      borderRadius: "1.25rem",
      objectFit: "cover",
      aspectRatio: "16/9",
    },
  },
  embeded_link: {
    width: "76%",
    marginTop: "0.5rem",
  },
}));
